import { SalesforceAccountProductBundle } from '@weave/schema-gen-ts/dist/schemas/salesforce/v1/salesforce.pb';
import { FreeTrialSubscriptionQueries } from '@frontend/api-free-trial-subscription';

interface UseBundleUpgradeEligibilityProps {
  locationIds: string[];
  enabled?: boolean;
}

export const useBundleUpgradeEligibility = ({ locationIds = [], enabled = true }: UseBundleUpgradeEligibilityProps) => {
  const { data: bundleUpgradeEligibility, isLoading: isLoadingBundleUpgradeEligibility } =
    FreeTrialSubscriptionQueries.useGetBundleUpgradeEligibility(
      {
        locationIds,
      },
      {
        enabled: enabled && !!locationIds.length,
      }
    );

  const isBundleUpgradeEligible = !!bundleUpgradeEligibility?.isBundleTrialEligible;
  const recommendedBundle =
    bundleUpgradeEligibility?.recommendedBundle ||
    SalesforceAccountProductBundle.UNKNOWN_SALESFORCE_ACCOUNT_PRODUCT_BUNDLE;

  return {
    isBundleUpgradeEligible,
    recommendedBundle,
    isLoadingBundleUpgradeEligibility,
  };
};
